import React from 'react';
import FooterLayoutComponent from '../layout/FooterLayoutComponent';

const BbsViewComponent = props => {
    const { info, onClickBtnList } = props;
    return (
        <main class="story-news">
            <div class="body">
                {info ?
                    <section class="article-view">
                        <div class='head'>
                            <div class='title'>
                                [{info.bbsCode.names['en']}] {info.subject}
                            </div>
                            <div class='date'>{info.createdDatetime}</div>
                        </div>
                        <div class='tui-editor-contents'
                            dangerouslySetInnerHTML={{ __html: info.context }}>
                        </div>

                        <div class='controller'>
                            <span class='button'>
                                <button
                                    onClick={onClickBtnList}
                                    class='btn btn-list'>LIST</button>
                            </span>
                        </div>
                    </section>
                    : null}
            </div>
            <FooterLayoutComponent
                {...props} />
        </main>
    )
}

export default BbsViewComponent;